<div class="modal-wrapper">
  <p>Edit Smart Badge</p>
  <button class="close-icon" (click)="closeDialog()">
    <mat-icon> clear </mat-icon>
  </button>
  <app-badging-questions
    class="w-full"
    [socialRoomSetId]="socialRoomSetId"
    [inRoom]="true"
    (updatedSmartBadge)="closeDialog(true)"
  />
  @if (!isMobile) {
    <div class="badge-preview-position">
      <app-badging-info
        [showRoomActionIcons]="true"
        [isPreviewCard]="true"
        [customStyle]="true"
        [user]="user"
        [previewBadgeInfo]="profile"
      ></app-badging-info>
    </div>
  }
</div>
